export default {
    title: 'Password recovery',
    form: {
        fields: {
            phone: {
                label: 'Phone',
                validations: {
                    require: 'this field is required',
                },
            },
            password: {
                label: 'New password',
                validations: {
                    require: 'this field is required',
                    repeat: 'Passwords must match',
                },
            },
            repeatPassword: {
                label: 'Repeat the new password',
                validations: {
                    require: 'this field is required',
                    repeat: 'Passwords must match',
                },
            },
        },
        submitButton: 'Войти',
    },
    labels: {
        phoneStep:
            'Enter your phone number. We will show the number you need to call to verify and reset your password.',
        callbackVerificationStep: 'Confirm your phone number via callback',
        callToInfo:
            'Please call from {{login}} to {{callTo}}. After the call, click “I have called”.',
        createPasswordStep: 'Great :) Now enter your new password',
    },
    buttons: {
        sendCode: 'Get number to call',
        createPassword: 'Change password',
        repeatVerification: 'Get number again',
        confirmCall: 'I have called',
    },
    messages: {
        successResetPassword: 'Password changed successfully',
        requestCallbackAgain: `Call number updated for {{phoneNumber}}`,
        callbackVerificationFailed:
            'Could not confirm the call. Go back and request the number again.',
    },
};
